import { Pipe, PipeTransform } from '@angular/core';
import { EnumIdsTcEstadoUnidadInspeccion } from 'src/app/components/_campanias/types/enum';

@Pipe({ name: 'IconoEstadoUnidadInspeccion' })
export class IconoEstadoUnidadInspeccionPipe implements PipeTransform {
    private allowedEstados = [
        EnumIdsTcEstadoUnidadInspeccion.ID_PREINSCRITA,
        EnumIdsTcEstadoUnidadInspeccion.ID_ELIMINADA,
        EnumIdsTcEstadoUnidadInspeccion.ID_EN_TRAMITE,
        EnumIdsTcEstadoUnidadInspeccion.ID_RECHAZADA_TEMP,
        EnumIdsTcEstadoUnidadInspeccion.ID_RECHAZADA,
        EnumIdsTcEstadoUnidadInspeccion.ID_AUTORIZADA_POR_EA,
        EnumIdsTcEstadoUnidadInspeccion.ID_AUTORIZADA_EXPORT,
        EnumIdsTcEstadoUnidadInspeccion.ID_SUSPENDIDA,
        EnumIdsTcEstadoUnidadInspeccion.ID_BAJA,
        EnumIdsTcEstadoUnidadInspeccion.ID_PTE_AFORAR,
    ];
    transform(value: number): string {
        if (value && this.allowedEstados.indexOf(value) !== -1) {
            return './assets/images/EstadoSolicitud/EstadoUnidadInspeccion/' + value + '.png';
        }
        return './assets/images/EstadoSolicitud/EstadoUnidadInspeccion/0.png';
    }
}
